import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchIcon } from '@utils/icons';
import styles from './searchInput.module.css';

interface ISearchInputProps {
  value: string;
  onChange: (v: string) => void;
}

/** The keyword search box in the FilterBar's header row (both views). */
export const SearchInput = memo(function SearchInput({ value, onChange }: ISearchInputProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.wrap}>
      <span className={styles.icon} aria-hidden="true">
        <SearchIcon size={16} />
      </span>
      <input
        className={styles.input}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('activities.search.placeholder')}
        aria-label={t('activities.search.placeholder')}
      />
    </div>
  );
});
